import { CanDeactivateFormGuard } from './guards/can-deactivate-form.guard';

export { CanDeactivateForm } from './guards/can-deactivate-form.guard';
export { CanDeactivateFormGuard } from './guards/can-deactivate-form.guard';

export const GUARDS: any[] = [
	CanDeactivateFormGuard
];
